import React, {
  useEffect,
  useState,
} from 'react';

import {
  Outlet,
  useNavigate,
} from 'react-router-dom';

import { authFetch } from '../utils/authFetch';

import {
  startWebLocationScheduler,
  stopWebLocationScheduler,
} from '../utils/backgroundLocation';

export default function LocationConsentGuard() {
  const navigate = useNavigate();

  const [ready, setReady] =
    useState(false);

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      try {
        const res = await authFetch(
          '/api/localizzazione/consenso'
        );

        if (!res || !res.ok) {
          if (mounted) setReady(true);
          return;
        }

        const data = await res.json();

        if (
          data.required &&
          !data.accepted
        ) {
          navigate(
            '/consenso-localizzazione',
            { replace: true }
          );

          return;
        }

        if (data.required) {
          startWebLocationScheduler();
        }

        if (mounted) {
          setReady(true);
        }
      } catch {
        if (mounted) {
          setReady(true);
        }
      }
    };

    check();

    return () => {
      mounted = false;

      /*
       * Se il guard rimane montato nel layout
       * generale puoi anche togliere questa
       * chiamata.
       */
      stopWebLocationScheduler();
    };
  }, [navigate]);

  if (!ready) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center text-sm text-gray-500">
        Caricamento...
      </div>
    );
  }

  return <Outlet />;
}